// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3iyu4","col":"CardReaderDesc_col__2gZ3C","label":"CardReaderDesc_label__RfvnQ"};